var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransfer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6631 18.6025C20.8827 18.3829 21.2383 18.3829 21.458 18.6025L22.4277 19.5723C22.9403 20.0848 22.9403 20.9152 22.4277 21.4277L21.458 22.3975C21.2383 22.6171 20.8827 22.6171 20.6631 22.3975C20.4435 22.1778 20.4435 21.8222 20.6631 21.6025L21.2031 21.0625H18.5C18.1893 21.0625 17.9375 20.8107 17.9375 20.5C17.9375 20.1893 18.1893 19.9375 18.5 19.9375H21.2031L20.6631 19.3975C20.4435 19.1778 20.4435 18.8222 20.6631 18.6025ZM19 10C21.2091 10 23 11.7909 23 14V16.5C23 17.0523 22.5523 17.5 22 17.5H20.5996C18.6117 17.5002 17.0002 19.1117 17 21.0996C17 21.5967 16.5967 22 16.0996 22H12C9.79086 22 8 20.2091 8 18V14C8 11.7909 9.79086 10 12 10H19ZM15.5 14.5C14.6716 14.5 14 15.1716 14 16C14 16.8284 14.6716 17.5 15.5 17.5C16.3284 17.5 17 16.8284 17 16C17 15.1716 16.3284 14.5 15.5 14.5ZM11 12.25C10.5858 12.25 10.25 12.5858 10.25 13C10.25 13.4142 10.5858 13.75 11 13.75C11.4142 13.75 11.75 13.4142 11.75 13C11.75 12.5858 11.4142 12.25 11 12.25Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransfer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transfer.f3a26f5a4ac92a04eeae3c11566fca73.svg";